<script lang="ts">
  import validate from '../lib/utils/validationRules'
  import { formatDisplayAmountWithSign } from '../lib/transaction/metric'

  import CardImage from './components/CardImage.svelte'
  import CardLogo from './components/CardLogo.svelte'

  export let card: object

  const isPartner = card.type === 'PARTNER';
  const INTERNAL_AMOUNT_TEXT = 'Поддержать'
  const PARTNER_AMOUNT_TEXT = 'Купить'


  function getTariff() {
    const { billTariffs } = card
    if (validate.isNull(billTariffs) || validate.isEmptyArray(billTariffs)) {
      return null
    }

    const [ tariff ] = billTariffs
    if (validate.isNotObject(tariff)) {
      return null
    }

    return tariff
  }

  function formatPrice(value, separator = ' ') {
    const preparedValue = String(value).replace(/\s/g, '').replace(/,/g, '.')
    return preparedValue.replace(/(\d)(?=(?:\d{3})+\b)/gm, `$1${separator}`)
  }

  function getFormattedAmount(amount) {
    const formattedAmount = formatPrice(amount / 100)
    const formattedDisplayAmount = formatDisplayAmountWithSign(formattedAmount)

    return formattedDisplayAmount
  }

  const displayAmount = (() => {
    if (isPartner) {
      if (validate.isNull(card.amount)) {
        return PARTNER_AMOUNT_TEXT;
      }

      return getFormattedAmount(card.amount)
    }

    const tariff = getTariff()

    if (validate.isNull(tariff)) {
      return INTERNAL_AMOUNT_TEXT;
    }

    if (validate.isNull(tariff.amount)) {
      return INTERNAL_AMOUNT_TEXT;
    }

    return getFormattedAmount(tariff.amount)
  })()
</script>

<a href={card.payLink} class="card" target="_blank" rel="noopener noreferrer">
  <CardImage imageLink={card.billImageLink} />
  <div class="card-content">
    <CardLogo logoLink={card.projectLogoLink} projectName={card.projectName} />
    <div class="card-title">{card.projectName}</div>
    {#if card.description}
      <div class="card-description">{@html card.description}</div>
    {/if}
    <div class="card-amount">{displayAmount}</div>
  </div>
</a>

<style>
  .card {
    overflow: hidden;
    border-radius: 5px;
    text-decoration: none;
    box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15);
    cursor: pointer;
  }

  .card-content {
    position: relative;
    padding: 17px 20px;
    background-color: #fff;
  }

  .card-title {
    margin: 0 0 15px;
    padding: 0 40px 0 0;
    font-size: 12px;
    line-height: 15px;
    color: #212121;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    opacity: 0.5;
  }

  .card-description {
    max-height: 39px;
    margin-bottom: 15px;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #212121;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .card-description * {
    margin: 0;
  }

  .card-amount {
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    color: #212121;
  }
</style>
